<template>
  <div class="article-detail main-top-border main-bg">
    <div class="main-wrap">
      <nav-crumb class="crumb-pt"></nav-crumb>
      <div class="article-main">
        <h3 class="article-title">{{newDetail.news.title}}</h3>
        <p class="article-time">{{newDetail.news.createTime}}   {{newDetail.news.createUserName}}</p>
        <div class="article-cont" v-html="newDetail.news.content">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import navCrumb from '../../components/crumb/index'
    import {getNewsInfoById} from '../../api/news'
  export default {
        data(){
            return {
                newDetail:{
                    news:{
                        title:'',
                        createTime:'',
                        createUserName:'',
                        content:''
                    }
                }
            }
        },
      components:{
          navCrumb
      },
      computed:{
            id(){
                let detailId=this.$route.params.id||'';
                return detailId;
            }
      },
      created () {
          console.log("detail",this.id);
          this.getNewDetail();
      },
      mounted(){
          //console.log("detail",this.$route.params.id)
      },
      methods:{
          toggleTab(tab, event) {
              console.log(tab, event);
          },
          getNewDetail(){
              getNewsInfoById({
                  newsId:this.id
              }).then(res=>{
                  this.newDetail=res.data;
                  let content = res.data.news.content;
                  this.newDetail.news.content=content.replace(/.png/g,'.png?x-oss-process=style/logo')
              }).catch(err=>{
                  console.log("getNewsInfoById",err);
              })
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .crumb-pt{
    padding:15px 0 24px 0;
  }
  .main-wrap{
    overflow: hidden;}
  .article-detail{
    .article-main{
      padding:30px;
      margin-bottom:30px;
      background-color:#ffffff;
      .article-title{
        font-size:30px;
        color:#333333;
        line-height:42px;
      }
      .article-time{font-size:20px;color:#949494;padding:30px 0 33px;}
      .article-cont{font-size:16px;line-height:24px;}
    }
  }

</style>

